const DOMAIN_QA = "https://d3ab4pgc1q9ec1.cloudfront.net";
const CLIENT_ID_QA = "3k6gnc9sd6an4k22rahg4fk9kc";
const AWS_PROJECT_REGION_QA = "us-west-2";
const AWS_COGNITO_IDENTITY_POOL_ID_QA =
  "us-west-2:4a94c5e7-4a4a-4485-aa1d-43471b9212f4";
const AWS_COGNITO_REGION_QA = "us-west-2";
const AWS_USER_POOLS_ID_QA = "us-west-2_zBiwOOBwj";
const AWS_USER_POOLS_WEB_CLIENT_ID_QA = "3k6gnc9sd6an4k22rahg4fk9kc";
const AUTH_ENDPOINT_QA = `${DOMAIN_QA}/auth`;

const config = {
  baseURL: DOMAIN_QA,
  clientId: CLIENT_ID_QA,
  aws_project_region: AWS_PROJECT_REGION_QA,
  aws_cognito_identity_pool_id: AWS_COGNITO_IDENTITY_POOL_ID_QA,
  aws_cognito_region: AWS_PROJECT_REGION_QA,
  aws_user_pools_id: AWS_USER_POOLS_ID_QA,
  aws_user_pools_web_client_id: AWS_USER_POOLS_WEB_CLIENT_ID_QA,
  oauth: {},
  Auth: {
    endpoint: AUTH_ENDPOINT_QA,
    identityPoolId: AWS_COGNITO_IDENTITY_POOL_ID_QA,
    region: AWS_COGNITO_REGION_QA,
    userPoolId: AWS_USER_POOLS_ID_QA,
    userPoolWebClientId: AWS_USER_POOLS_WEB_CLIENT_ID_QA,
  },
};

export { config };
